export default __webpack_public_path__ + "992b6ef0a4773501fa09186a700798b4.png";